import { Origin, } from '../components/manage-installed-apps-page';
import { ModalNames } from '../components/modals/modals';
import { ComponentType, PaymentCollectionType, AppGroup, BundleAppOrigin, RenewalType, IncompleteSetupReason, } from '@wix/ambassador-marketplace/types';
export var MarketPermissions;
(function (MarketPermissions) {
    MarketPermissions["MANAGE_APPS"] = "app-market.manage-app";
    MarketPermissions["UPGRADE_APP"] = "app-market.upgrade-app";
    MarketPermissions["UPDATE_APP"] = "APP_MARKET.UPDATE_APP";
    MarketPermissions["INSTALL_APP"] = "APP_MARKET.INSTALL_APP";
    MarketPermissions["UNINSTALL_APPS"] = "APP_MARKET.UNINSTALL_APPS";
    MarketPermissions["DELETE_APP"] = "APP_MARKET.DELETE_APP";
    MarketPermissions["ADD_AGAIN"] = "APP_MARKET.ADD_AGAIN";
    MarketPermissions["OPEN_APP"] = "APP_MARKET.OPEN_APP";
})(MarketPermissions || (MarketPermissions = {}));
export var isPendingApp = function (app) {
    return app.group === AppGroup.PENDING;
};
export var isBusinessApp = function (app) {
    return !isPendingApp(app) && !isRegularApp(app);
};
export var isRegularApp = function (app) {
    return app.group === AppGroup.INSTALLED;
};
export var isPendingAndNotBundle = function (app, bundleApps) {
    if (bundleApps === void 0) { bundleApps = []; }
    return isPendingApp(app) && !isAppListedAsBundle(app, bundleApps);
};
export var isAppListedAsBundle = function (app, bundleApps) {
    if (bundleApps === void 0) { bundleApps = []; }
    return bundleApps === null || bundleApps === void 0 ? void 0 : bundleApps.some(function (bundleApp) { return bundleApp.webSolutionBase.id === app.webSolutionBase.id; });
};
export var getAppWidgets = function (app) {
    return ((app.components &&
        app.components.filter(function (comp) {
            return comp.compType === ComponentType.WIDGET ||
                comp.compType === ComponentType.WIDGET_OUT_OF_IFRAME;
        })) ||
        []);
};
export var isEmbeddedScriptApp = function (app) {
    var embeddedComps = app.components
        ? app.components.filter(function (comp) { return comp.compType === ComponentType.EMBEDDED_SCRIPT; })
        : [];
    return !!(embeddedComps === null || embeddedComps === void 0 ? void 0 : embeddedComps.length);
};
export var canUsePremiumApp = function (app, siteIsPremium) {
    return (siteIsPremium ||
        !(app.webSolutionBase.pricing &&
            app.webSolutionBase.pricing.isRequiredWixPremium &&
            app.eligibleForUpgrade));
};
export var openSettingsUrl = function (app, openModal, embeddedScriptAppsStatus) {
    var url = getAppSettingsPageUrl(app);
    var appInstance = app.instance;
    var innerUrl = url.includes('?')
        ? url + "&instance=" + appInstance
        : url + "?instance=" + appInstance;
    if (isEmbeddedScriptApp(app) &&
        embeddedScriptAppsStatus[app.webSolutionBase.id]) {
        var embeddedScriptParams = JSON.stringify(embeddedScriptAppsStatus[app.webSolutionBase.id]);
        innerUrl = innerUrl + "&embeddedScriptParams=" + embeddedScriptParams;
    }
    openModal(ModalNames.APP_SETTINGS, { app: app, settingsUrl: innerUrl });
};
export var getAppDashboardData = function (app) {
    var _a, _b;
    var dashboardComps = app.components
        ? app.components.filter(function (comp) { return comp.compType === ComponentType.DASHBOARD; })
        : [];
    return ((dashboardComps === null || dashboardComps === void 0 ? void 0 : dashboardComps.length) && ((_b = (_a = dashboardComps[0]) === null || _a === void 0 ? void 0 : _a.compData) === null || _b === void 0 ? void 0 : _b.dashboardComponentData));
};
export var isDashboardApp = function (app) {
    var _a, _b;
    var dashboardComps = (_a = app === null || app === void 0 ? void 0 : app.components) === null || _a === void 0 ? void 0 : _a.filter(function (comp) { return comp.compType === ComponentType.DASHBOARD; });
    var dashboardPlatformComps = (_b = app === null || app === void 0 ? void 0 : app.components) === null || _b === void 0 ? void 0 : _b.filter(function (comp) { return comp.compType === ComponentType.DASHBOARD_PLATFORM; });
    return (dashboardComps === null || dashboardComps === void 0 ? void 0 : dashboardComps.length) || (dashboardPlatformComps === null || dashboardPlatformComps === void 0 ? void 0 : dashboardPlatformComps.length);
};
export var getAppPages = function (app) {
    return ((app.components &&
        app.components.filter(function (comp) {
            return comp.compType === ComponentType.PAGE ||
                comp.compType === ComponentType.PAGE_OUT_OF_IFRAME;
        })) ||
        []);
};
export var getBuilderComps = function (app) {
    return ((app.components &&
        app.components.filter(function (comp) {
            return comp.compType === ComponentType.STUDIO ||
                comp.compType === ComponentType.STUDIO_WIDGET;
        })) ||
        []);
};
export var getEditorPlatformComps = function (app) {
    return ((app.components &&
        app.components.filter(function (comp) { return comp.compType === ComponentType.PLATFORM; })) ||
        []);
};
export var getDashboardPlatformComps = function (app) {
    return ((app.components &&
        app.components.filter(function (comp) { return comp.compType === ComponentType.DASHBOARD_PLATFORM; })) ||
        []);
};
export var getEditorWebComps = function (app) {
    return ((app.components &&
        app.components.filter(function (comp) { return comp.compType === ComponentType.WEB; })) ||
        []);
};
export var addOnlyOnceApp = function (app) {
    var _a;
    var appWidgets = getAppWidgets(app).filter(function (comp) { return comp.compType === ComponentType.WIDGET; });
    var appOutOfIframeWidgets = getAppWidgets(app).filter(function (comp) { return comp.compType === ComponentType.WIDGET_OUT_OF_IFRAME; });
    var appWidgetsData = appWidgets.map(function (widget) { return widget.compData; });
    var appOutOfIframeWidgetsData = appOutOfIframeWidgets.map(function (widget) { return widget.compData; });
    var addOnlyOnceWidgets = appWidgetsData.filter(function (data) { return data === null || data === void 0 ? void 0 : data.addOnlyOnce; });
    var addOnlyOnceOutOfIframeWidgets = appOutOfIframeWidgetsData.filter(function (data) { var _a; return (_a = data === null || data === void 0 ? void 0 : data.widgetData) === null || _a === void 0 ? void 0 : _a.addOnlyOnce; });
    return ((addOnlyOnceWidgets === null || addOnlyOnceWidgets === void 0 ? void 0 : addOnlyOnceWidgets.length) || (addOnlyOnceOutOfIframeWidgets === null || addOnlyOnceOutOfIframeWidgets === void 0 ? void 0 : addOnlyOnceOutOfIframeWidgets.length) || ((_a = getAppPages(app)) === null || _a === void 0 ? void 0 : _a.length));
};
export var shouldShowAddAgain = function (app, origin) {
    return (!addOnlyOnceApp(app) &&
        isAppInstalled(app) &&
        origin === Origin.EDITOR &&
        appHasEditor(app));
};
export var isPermittedToDelete = function (app, permissions) {
    return (!!appHasEditor(app) || (permissions === null || permissions === void 0 ? void 0 : permissions.some(function (p) { return p === MarketPermissions.UNINSTALL_APPS; })));
};
export var isAppInstalled = function (app) {
    return app.group === AppGroup.INSTALLED;
};
export var appHasEditor = function (app) {
    var _a, _b, _c, _d, _e;
    return ((_a = getAppPages(app)) === null || _a === void 0 ? void 0 : _a.length) || ((_b = getAppWidgets(app)) === null || _b === void 0 ? void 0 : _b.length) || ((_c = getBuilderComps(app)) === null || _c === void 0 ? void 0 : _c.length) || ((_d = getEditorPlatformComps(app)) === null || _d === void 0 ? void 0 : _d.length) || ((_e = getEditorWebComps(app)) === null || _e === void 0 ? void 0 : _e.length);
};
export var getAppCheckStatusUrl = function (app) {
    return getAppDashboardData(app).checkStatusUrl;
};
export var getAppSettingsPageUrl = function (app) {
    return getAppDashboardData(app).settingsPageUrl;
};
export var isWixApp = function (companyId) {
    return companyId === 'ad147a73-a40e-4e50-8344-2ad33592790d' || companyId === 'a60ac714-5c5a-4c38-a285-573752f04876';
};
export var wixChatBotLink = 'https://www.wix.com/support/conversations/category/contact';
export var isBundleApp = function (app) {
    return app.group === AppGroup.BUNDLE;
};
export var isBundleAppAndInstalled = function (app) {
    var _a;
    return isBundleApp(app) && ((_a = app) === null || _a === void 0 ? void 0 : _a.upgradeSuggestion);
};
export var isBundleAppAndNotInstalled = function (app) {
    var _a;
    return isBundleApp(app) && !((_a = app) === null || _a === void 0 ? void 0 : _a.upgradeSuggestion);
};
export var isBundleAppFromVoucher = function (app) {
    return (isBundleApp(app) &&
        app.appOrigin === BundleAppOrigin.VOUCHER);
};
export var isNewVersionAvailable = function (app, experiments) {
    return (experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.update.flow')) &&
        !!app.shouldUpdateVersion;
};
export var isPremiumFromBundle = function (app) {
    return (app.isUpgraded &&
        app.paymentCollectionType === PaymentCollectionType.NON_PAYABLE &&
        app.premiumAutoRenew === RenewalType.UNKNOWN);
};
export var isSetupIncomplete = function (app, experiments) {
    return (experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.complete-setup')) &&
        (app.incompleteSetupReason === IncompleteSetupReason.PENDING_CONFIGURATION ||
            app.incompleteSetupReason === IncompleteSetupReason.PENDING_CONSENT) &&
        !isPendingApp(app);
};
export var enableDeleteMLApp = function (app, experiments) {
    return (app.webSolutionBase.id === '14d84998-ae09-1abf-c6fc-3f3cace5bf19' &&
        experiments.enabled('specs.marketplace.delete-ml-app'));
};
//# sourceMappingURL=appUtils.js.map